var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKujira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo/Kujira"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#E53935"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    cx: 18.5,
    cy: 17.9999,
    r: 16,
    fill: "#263238",
    stroke: "#E53935",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE9\xAF\xA8",
    d: "M30.2642 10.6434V8.94776H24.893C24.6048 7.85211 24.3166 6.8869 24.0022 5.99994L22.1943 6.31298C22.5087 7.09559 22.8231 7.98255 23.1114 8.94776H17.4258V10.6434H30.2642ZM16.5087 23.2434V12.4173H13.8624C14.4127 11.6086 14.9629 10.6173 15.5131 9.41733V8.16516H11.19C11.4258 7.64342 11.6354 7.12168 11.845 6.57385L10.1681 6.05211C9.3821 8.60863 8.15065 10.6695 6.5 12.2608L6.89301 14.113C7.23362 13.7999 7.57424 13.4869 7.88865 13.1478V23.2434H16.5087ZM12.0546 12.4173H8.54367C9.22489 11.5825 9.87991 10.6434 10.4563 9.65211H13.7576C13.1812 10.6956 12.631 11.6347 12.0546 12.4173ZM22.8493 29.9999C24.1594 29.9999 24.8406 29.2695 24.8406 27.8347V20.3999H29.0065V12.9912H18.8144V20.3999H23.0065V27.3912C23.0065 28.0434 22.7445 28.3825 22.2205 28.3825C21.6179 28.3825 20.9891 28.3304 20.3603 28.2521L20.7271 29.9999H22.8493ZM11.452 17.0608H9.5131V13.9565H11.452V17.0608ZM14.8843 17.0608H12.9716V13.9565H14.8843V17.0608ZM27.2249 18.7565H20.5961V14.6608H27.2249V18.7565ZM14.8843 21.6782H12.9716V18.5739H14.8843V21.6782ZM11.452 21.6782H9.5131V18.5739H11.452V21.6782ZM29.1114 28.7999L30.5 27.8347C29.7926 26.1652 28.7969 24.2347 27.4869 22.0173L26.0983 22.8521C27.3559 25.0173 28.3777 26.9999 29.1114 28.7999ZM18.1332 29.2434C19.286 27.4434 20.2817 25.3043 21.1201 22.8521L19.6004 22.1217C18.7882 24.4695 17.8188 26.5043 16.7183 28.226L18.1332 29.2434ZM15.9585 27.4695L17.2424 27.1565C16.8755 25.9043 16.5087 24.8086 16.0895 23.8695L14.8581 24.2347C15.2773 25.2782 15.6441 26.3478 15.9585 27.4695ZM13.1812 28.9825L14.5437 28.826C14.3865 26.8434 14.0983 25.2782 13.679 24.1304L12.369 24.2869C12.7882 25.3825 13.0502 26.9478 13.1812 28.9825ZM8.17686 29.6869C8.72707 28.1478 9.06769 26.3999 9.22489 24.4173L7.81004 24.2347C7.67904 26.113 7.31223 27.7825 6.73581 29.2434L8.17686 29.6869ZM10.3777 29.3739L11.7402 29.2173C11.6878 27.1565 11.5568 25.513 11.3734 24.313L10.1157 24.4695C10.2467 25.6173 10.3253 27.2608 10.3777 29.3739Z",
    fill: "#E53935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8348 12.4804C21.5925 9.17769 17.4838 9.29384 13.5085 12.8289C9.5333 16.3639 9.63293 20.8199 13.8074 26.1969L14.7771 16.3329L25.2307 13.9827L25.8348 12.4804Z",
    fill: "url(#paint0_linear_1855_15247)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5645 10.4826C13.8 9.77053 10.6646 10.7416 11.0893 12.0101C11.2248 12.415 12.223 11.7618 13.5405 12.2289C14.1836 11.9346 16.3585 10.7654 16.5645 10.4826Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8401 9.78979C22.2024 9.78979 24.3627 10.6544 26.0219 12.0844L25.7475 12.7414C24.1859 11.3261 22.1137 10.4638 19.8401 10.4638C14.9802 10.4638 11.0404 14.4036 11.0404 19.2635C11.0404 24.1234 14.9802 28.0632 19.8401 28.0632C20.3682 28.0632 20.8855 28.0166 21.388 27.9275L21.205 28.6396C20.7593 28.7039 20.3036 28.7372 19.8401 28.7372C14.6079 28.7372 10.3664 24.4957 10.3664 19.2635C10.3664 14.0313 14.6079 9.78979 19.8401 9.78979Z",
    fill: "url(#paint1_linear_1855_15247)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5592 11.3251C21.8049 11.3251 23.8449 12.2233 25.3528 13.6867L25.1426 14.1899C23.7108 12.7193 21.7459 11.8119 19.5779 11.8119C15.1971 11.8119 11.6457 15.5169 11.6457 20.0873C11.6457 24.6577 15.1971 28.3628 19.5779 28.3628C20.242 28.3628 20.887 28.2776 21.5035 28.1173L21.4704 28.2525C20.8564 28.3981 20.2166 28.4751 19.5592 28.4751C14.9164 28.4751 11.1527 24.6359 11.1527 19.9001C11.1527 15.1643 14.9164 11.3251 19.5592 11.3251Z",
    fill: "url(#paint2_linear_1855_15247)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4562 26.0197C15.0207 25.3219 13.5753 22.5614 17.2243 19.7704C20.4948 17.2689 26.2616 18.2461 26.2616 12.565C26.2616 12.3968 25.9876 11.8424 25.7647 12.0681C25.3398 12.4985 24.5764 13.9639 22.5726 13.7076C17.4328 13.0503 11.4103 13.1577 12.2921 23.3955C12.2921 25.4366 15.2747 26.8881 16.4562 26.0197Z",
    fill: "url(#paint3_linear_1855_15247)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6014 14.3071C14.5025 14.0909 13.4204 13.9827 12.3551 13.9827C8.67734 13.9827 8.24782 16.5324 8.54543 16.789C8.92946 17.1201 11.6418 15.2658 12.9458 17.614C13.8152 19.1795 14.7004 18.0772 15.6014 14.3071Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4372 26.0225C16.5382 25.4268 16.7033 24.9886 16.9326 24.7081C17.3469 24.2012 18.1765 23.5507 18.3479 23.7147C18.4652 23.827 18.3595 24.0137 18.2772 24.2652C18.19 24.5318 18.0914 24.8444 18.3479 25.3754C18.6802 26.0635 18.7809 26.5433 18.6501 26.8149C19.4303 26.6994 20.0904 26.8938 20.6305 27.3982C21.4407 28.1547 22.2909 27.8 21.91 28.4817C21.8717 28.5504 20.4671 28.9241 18.1102 28.5206C17.6579 28.4432 16.9524 28.1271 15.9937 27.5725C15.141 27.1239 14.585 26.7877 14.3259 26.5639C14.0668 26.3401 13.8668 26.0234 13.7258 25.6137L15.7086 26.2059C16.1245 26.1218 16.3457 26.0552 16.3723 26.0061C16.3749 26.0011 16.4364 26.0276 16.4372 26.0225Z",
    fill: "#263238"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3403 11.8487C22.098 8.54591 17.9892 8.66206 14.014 12.1971C10.0388 15.7321 10.1384 20.1882 14.3129 25.5652L15.2826 15.7011L25.7362 13.3509L26.3403 11.8487Z",
    fill: "url(#paint4_linear_1855_15247)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0699 9.8508C14.3055 9.13874 11.17 10.1098 11.5947 11.3783C11.7303 11.7832 12.7284 11.13 14.0459 11.5971C14.6891 11.3028 16.864 10.1336 17.0699 9.8508Z",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3456 9.15802C22.7078 9.15802 24.8682 10.0226 26.5274 11.4527L26.253 12.1096C24.6914 10.6943 22.6192 9.83204 20.3456 9.83204C15.4856 9.83204 11.5459 13.7718 11.5459 18.6317C11.5459 23.4916 15.4856 27.4314 20.3456 27.4314C20.8737 27.4314 21.3909 27.3849 21.8935 27.2957L21.7104 28.0078C21.2648 28.0721 20.809 28.1054 20.3456 28.1054C15.1134 28.1054 10.8719 23.8639 10.8719 18.6317C10.8719 13.3995 15.1134 9.15802 20.3456 9.15802Z",
    fill: "url(#paint5_linear_1855_15247)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0666 10.6933C22.3123 10.6933 24.3523 11.5915 25.8602 13.0549L25.65 13.5581C24.2182 12.0875 22.2534 11.1801 20.0854 11.1801C15.7045 11.1801 12.1532 14.8851 12.1532 19.4555C12.1532 24.0259 15.7045 27.7309 20.0854 27.7309C20.7494 27.7309 21.3944 27.6458 22.0109 27.4854L21.9778 27.6207C21.3639 27.7663 20.7241 27.8433 20.0666 27.8433C15.4239 27.8433 11.6602 24.0041 11.6602 19.2683C11.6602 14.5324 15.4239 10.6933 20.0666 10.6933Z",
    fill: "url(#paint6_linear_1855_15247)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9616 25.3879C15.5261 24.6901 14.0808 21.9296 17.7298 19.1386C21.0003 16.6371 26.767 17.6143 26.767 11.9332C26.767 11.765 26.4931 11.2106 26.2702 11.4363C25.8453 11.8667 25.0819 13.3321 23.078 13.0758C17.9382 12.4185 11.9157 12.5259 12.7976 22.7636C12.7976 24.8048 15.7802 26.2563 16.9616 25.3879Z",
    fill: "url(#paint7_linear_1855_15247)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1092 13.6753C15.0103 13.4591 13.9282 13.3509 12.8629 13.3509C9.18515 13.3509 8.75563 15.9006 9.05325 16.1572C9.43727 16.4883 12.1496 14.634 13.4537 16.9822C14.323 18.5477 15.2082 17.4454 16.1092 13.6753Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9451 25.3907C17.046 24.7949 17.2111 24.3568 17.4404 24.0762C17.8547 23.5693 18.6843 22.9188 18.8557 23.0829C18.973 23.1951 18.8673 23.3819 18.785 23.6334C18.6978 23.8999 18.5992 24.2126 18.8557 24.7436C19.188 25.4316 19.2887 25.9114 19.1579 26.1831C19.9381 26.0676 20.5982 26.262 21.1383 26.7663C21.9485 27.5228 22.7987 27.1682 22.4178 27.8499C22.3795 27.9186 20.9749 28.2922 18.618 27.8887C18.1657 27.8113 17.4602 27.4953 16.5015 26.9406C15.6488 26.492 15.0929 26.1559 14.8337 25.9321C14.5746 25.7083 14.3746 25.3915 14.2336 24.9818L16.2164 25.574C16.6323 25.49 16.8535 25.4233 16.8801 25.3742C16.8828 25.3693 16.9442 25.3958 16.9451 25.3907Z",
    fill: "#546E7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_15247",
    x1: 16.2409,
    y1: 11.7723,
    x2: 11.5278,
    y2: 16.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_15247",
    x1: 12.352,
    y1: 14.6235,
    x2: 13.5087,
    y2: 25.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1855_15247",
    x1: 13.1495,
    y1: 13.4072,
    x2: 14.446,
    y2: 26.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1855_15247",
    x1: 17.0218,
    y1: 19.2635,
    x2: 17.4111,
    y2: 27.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1855_15247",
    x1: 16.7477,
    y1: 11.1405,
    x2: 12.0346,
    y2: 15.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1855_15247",
    x1: 12.8593,
    y1: 13.9917,
    x2: 14.0161,
    y2: 24.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#607D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546E7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1855_15247",
    x1: 13.6567,
    y1: 12.7754,
    x2: 14.9534,
    y2: 25.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#607D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546E7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1855_15247",
    x1: 17.5285,
    y1: 18.6317,
    x2: 17.9178,
    y2: 27.1122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#607D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546E7A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKujira);
export default __webpack_public_path__ + "static/media/Kujira.7ff0df33.svg";
export { ForwardRef as ReactComponent };